import { configureStore } from "@reduxjs/toolkit";
import { youtubeReducer } from "./redux";

const store = configureStore({
    reducer: {
        youtube: youtubeReducer
    }
})

export default store